<script lang="ts">
  import { _ } from 'svelte-i18n'
	import { slide } from 'svelte/transition'
  
  export let title: string

  let isShowContent: boolean = false

  const visibleItemsHandler = async () => {
    isShowContent = !isShowContent
  }
</script>

<div class="accordion">
  <div 
    class="flex items-center justify-between" 
    on:click={visibleItemsHandler}
  >
    <div class="flex items-center flex-1">
      <i 
        class="icon-chevron-right"
        style:transform={isShowContent ? 'rotate(90deg)' : 'rotate(0)'}  
      />
      
      <div class="title ">{title}</div>
    </div>
  </div>

  {#if isShowContent}
    <div class="content" transition:slide>
      <hr />
      <slot />
    </div>
  {/if}
</div>

<style lang="scss">
  * {
    box-sizing: border-box;
    color: #30333D;
    text-decoration: none;
  }

  hr {
    margin-top: 0;
  }

  i {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  ::before {
    margin: 0;
  }

  .icon-chevron-right {
    cursor: pointer;
    transition: transform .3s;
    font-size: 10px;
  }

  .accordion {
    margin-top: 20px;
    border: 1px solid;
    width: 100%;
    border-radius: 10px;
    padding: 24px;
    border-color: #B6C8F9;
    margin-bottom: 24px;

    @media (max-width: 576px) {
      padding: 12px;
      margin-top: 12px;
    }
  }

  .content {
    padding-top: 20px;
    font-size: 16px;
    font-weight: 600;
    line-height: 23px;
    margin-bottom: -24px;

    @media (max-width: 576px) {
      padding-top: 14px;
    }
  }

  .title {
    font-size: 18px;
    font-weight: 600;
    line-height: 26px;
    margin-left: 26px;

    @media (max-width: 576px) {
      font-size: 16px;
      margin: 0 16px;
    }
  }
</style>